<!--手机号/验证码登录弹框-->
<template>
  <div class="auth-login-container">

    <!-- 手机登录弹框 -->
  <div v-if="!isPc">
     <van-dialog
      v-model="loginShow"
      :show-confirm-button="false"
      :width="isPc?'7.36rem':'3.36rem'"
    >
      <template #default>

        <div  class="login-content">
          <!-- <div class="title">{{content.loginMobileTitle}}</div> -->
           <div class="title">{{type=='tel'?'验证码登录':'密码登录'}}</div>
          <div v-if="canClose" class="close-icon" @click="closeDialog"><van-icon name="cross" size="0.23rem" /></div>
          <div v-if="type=='tel'">
          <van-field
            v-model="loginForm.phone"
            type="tel"
            center
            clearable
            maxlength="11"
            :placeholder="content.loginPhoneTip"
            @click-left-icon="phoneAreaCodeChange"
          >
            <template #left-icon>
              <span style="cursor:pointer;">+{{areaCode}}</span>
            </template>
            <template #button>
              <span
                v-if="!isCount"
                style="color:#FF804C;font-size:0.16rem;cursor:pointer;"
                @click="getSmsCode"
              >{{content.loginGetCode}}</span>
              <van-count-down
                v-else
                style="color:#FF804C;font-size:0.16rem;"
                :time="countTime"
                :format="`ss ${content.ss}`"
                @finish="isCount=false"
              />
            </template>
          </van-field>
          <van-field
            v-model="loginForm.sms_code"
            type="digit"
            size="small"
            maxlength="6"
            :placeholder="content.loginVerificationTip"
          />
          </div>
          <div v-if="type=='password'">
          <van-field
            v-model="loginForm.phone"
            type="tel"
            center
            clearable
            maxlength="11"
            :placeholder="content.loginPhoneTip"
            @click-left-icon="phoneAreaCodeChange"
          >
            <template #left-icon>
              <span style="cursor:pointer;">+{{areaCode}}</span>
            </template>

          </van-field>
          <van-field
           type='password'
            v-model="loginForm.password"
            size="small"
            :placeholder="content.loginVerificationTipPassword"
          />
          </div>
          <div class="policy-check">
            <van-checkbox
              v-model="policyCheck"
              icon-size="0.18rem"
            >{{content.hasRead}}《
            <span class="policy-link" @click.stop="lookPolicy">{{content.policy}}</span>
            》</van-checkbox>
          </div>
          <van-button
            type="info"
            round
            class="loginBtn"
            :disabled="type=='tel'?!(loginForm.phone&&loginForm.sms_code&&policyCheck):!(loginForm.phone&&loginForm.password&&policyCheck)"
            color="linear-gradient(to right, #2A8AFA, #72C9FF)"
            @click="loginBtn"
          >{{content.loginIn}}</van-button>
        <div class="passwordTitle-tel" @click="changeType">{{type=='tel'?content.loginTitlePassword:content.loginTitleTel}}</div>

        </div>
      </template>
    </van-dialog>
     <!-- 一键登录弹框 -->
    <!-- <van-dialog
      v-model="OneloginShow"
      :show-confirm-button="false"
      :width="isPc?'7.36rem':'4.36rem'"
    > 
      <div class="boxOneLogin">
          <img src="https://yunicu.com/img/titleImg.9849ea77.png" style="width:100px;height:100px;margin:10px  auto 30px"/>
          <span style="font-size:13px">请开启数据流量，关闭wifi尝试一键登录功能！</span>
          <van-button
            type="info"
            round
            class="loginBtn"
            color="linear-gradient(to right, #2A8AFA, #72C9FF)"
            @click="getTelNumber"
            style="width:50%;margin:10px auto"
          >一键登录</van-button>
         <van-button
            @click="changeLoginShow"
            round
            class="loginBtn"
             style="width:50%;margin:10px auto"
          >其它登录方式
          </van-button>
      </div>
      
    </van-dialog> -->
  </div>
  <!-- 网页登录弹框 -->
  <div v-if="isPc">
    <van-dialog    
     class="PCdialog"
      v-model="OneloginShow"
      :show-confirm-button="false"
      :width="isPc?'7.36rem':'4.36rem'">
       <div class="login-wx-body" id='login_container'>
        <div class='PCTitle'>微信扫码登录</div>
         <div id="qrcode-container" class='qrcode-container'></div>
         <div class="weiBOttom">
            <span @click="changePC('password')">密码登录</span>
            <span @click="changePC('tel')">验证码登录</span>
         </div>
       </div>
    </van-dialog>
      <van-dialog
      v-model="loginShow"
      :show-confirm-button="false"
      :width="isPc?'7.36rem':'4.36rem'"
    >
      <template #default>
        <div  class="login-content-pc">
          <!-- <div class="title">{{content.loginMobileTitle}}</div> -->
          <div class="title">{{type=='tel'?'验证码登录':'密码登录'}}</div>
          <div v-if="canClose" class="close-icon" @click="closeDialog"><van-icon name="cross" size="0.23rem" /></div>

          <el-form class="maxHeight70 login-form-p beauty-scroll" v-if="type=='tel'">
            <el-form-item :label="content.loginPhoneLabel">
              <el-input
                v-model="loginForm.phone"
                :maxlength="11"
                :placeholder="content.loginPhoneTip">
                <template #append>
                  <span
                    v-if="!isCount"
                    style="color:#FF804C;font-size:0.16rem;cursor:pointer;"
                    @click="getSmsCode"
                  >{{content.loginGetCode}}</span>
                  <van-count-down
                    v-else
                    style="color:#FF804C;font-size:0.16rem;"
                    :time="countTime"
                    :format="`ss ${content.ss}`"
                    @finish="isCount=false"
                  />
                </template>
              </el-input>
            </el-form-item>
            <el-form-item :label="content.loginVerificationLabel">
              <el-input
                v-model="loginForm.sms_code"
                :maxlength="6"
                :placeholder="content.loginVerificationTip">
              </el-input>
            </el-form-item>
          </el-form>
           <el-form class="maxHeight70 login-form-p beauty-scroll" v-if="type=='password'">
            <el-form-item :label="content.loginPhoneLabel">
              <el-input
                v-model="loginForm.phone"
                :maxlength="11"
                :placeholder="content.loginPhoneTip">
              </el-input>
            </el-form-item>
            <el-form-item :label="content.loginVerificationLabelPassword">
              <el-input
                type="password"
                show-password
                v-model="loginForm.password"
                :placeholder="content.loginVerificationTipPassword">
              </el-input>
            </el-form-item>
          </el-form>
          <div class="policy-check">
            <van-checkbox
              v-model="policyCheck"
              icon-size="0.18rem"
            >{{content.hasRead}}《
            <span class="policy-link" @click.stop="lookPolicy">{{content.policy}}</span>
            》</van-checkbox>
          </div>
          <van-button
            type="info"
            round
            :disabled="type=='tel'?!(loginForm.phone&&loginForm.sms_code&&policyCheck):!(loginForm.phone&&loginForm.password&&policyCheck)"
            class="loginBtn"
            color="linear-gradient(to right, #2A8AFA, #72C9FF)"
            @click="loginBtn"
          >{{content.loginIn}}
          </van-button>
           <div style="display:flex">
            <div class="passwordTitle-tel" @click="changeType">{{type=='tel'?content.loginTitlePassword:content.loginTitleTel}}</div>
            <div class="passwordTitle-tel" style="margin-left:20px" @click="changePC('weixin')" v-if="weixinShow">扫码登录</div>
           </div>
          
        </div>
       
      </template>
    </van-dialog>
      <van-dialog    
     class="PCdialog"
      v-model="wxFormModel"
      :show-confirm-button="false"
      :width="isPc?'7.36rem':'4.36rem'">
        <template #default>
        <div  class="login-content-pc">
          <!-- <div class="title">{{content.loginMobileTitle}}</div> -->
          <div class="title">绑定手机号</div>
          <el-form class="maxHeight70 login-form-p beauty-scroll" >
            <el-form-item>
              <el-input
                v-model="loginForm.phone"
                :maxlength="11"
                placeholder="请输入手机号">
               <template #append>
                  <span
                    v-if="!isCount"
                    style="color:#FF804C;font-size:0.16rem;cursor:pointer;"
                    @click="getSmsCode"
                   >获取验证码</span>
                  <van-count-down
                    v-else
                    style="color:#FF804C;font-size:0.16rem;"
                    :time="countTime"
                    :format="`ss ${content.ss}`"
                    @finish="isCount=false"
                  />
                </template>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="loginForm.code"
                :maxlength="6"
                placeholder="请输入验证码">
              </el-input>
            </el-form-item>
         
          </el-form>
           <!-- <div class="passwordTitle-tel" style="margin-left:20px" @click="wxuuidLogin">登录</div> -->
            <van-button
            type="info"
            round
            class="loginBtn"
            color="linear-gradient(to right, #2A8AFA, #72C9FF)"
            @click="wxuuidLogin"
          >登录</van-button>
        </div>
       
      </template>
    </van-dialog>
  </div>
  
  
  <van-popup v-model="areaCodeShow" position="bottom" round :close-on-click-overlay="false">
      <van-picker
        :title="content.areaCode"
        show-toolbar
        :columns="areaCodeList"
        @confirm="areaCodeConfirm"
        @cancel="areaCodeShow=false"
      />
  </van-popup>
  </div>
</template>

<script>
import { PhoneNumberServer } from 'aliyun_numberauthsdk_web'; 
import { mapState } from 'vuex'
// eslint-disable-next-line no-unused-vars

import axios from "axios";
import { dateFormat } from '../../../utils/util';

export default {
  props:{
    streamId:{
      type: [Number, String],
      default: -1
    },
    canClose: {
      // 是否允许关闭
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isCount: false, // 验证码倒计时
      loginShow: false, // 登录弹框
      OneloginShow:false,
      loginForm: { // 登录框表单
        phone: '',
        sms_code: ''
      },
      policyCheck: false, // 同意协议
      countTime: 60000, // 验证码倒计时
      areaCodeShow: false, // 区号弹窗
      areaCode: '86', // 手机区号
      areaCodeList: ['86'],
      type:this.$route.query.live_meeting_id ==-1?'password':'tel',
      otherType:false,
      tokenInfo : {
          JwtToken: "",
          AccessToken: "",
        },
        phoneNumberServer:'',
        os:'',
        wxFormModel:false,
        wxForm:{},
        unionId:'',
        weixinShow:false
      
     
    }
  },
  mounted() {
    // this.getTelNumber()
    globalThis.vueApp = this; // 存储当前组件实例
     
     
  
  },
  // 在回调页面的 mounted/created 中解析 URL
created() {
console.log('666');

let domain_code = location.host.split('.')[1]

if(domain_code=='yunicu'){
    this.weixinShow=true
}
else{
     this.weixinShow=false
}
// 获取 hash 后的部分（去掉 #）
const hash = window.location.hash.substring(1); 
// 提取参数部分（从 ? 开始）
const queryString = hash.split('?')[1]; 
// 解析参数
const params = new URLSearchParams(queryString);
if(params.get("code")){
     this.loginShow=false
     this.pollLoginStatus(params.get("code")); 
}
else{
   return
}




},

  computed: {
    content() {
      return this.$store.state.content
    },
    lanuage() {
      return this.$store.state.lanuage
    },
    ...mapState(['isPc'])
  },
  methods: {
    getPlatform() {
      // eslint-disable-next-line no-undef
      if (typeof wx !== 'undefined' && wx.getSystemInfoSync) {
        return 'mina';
      }

      const userAgent = navigator.userAgent.toLowerCase();

      // 判断是否为 App
      if (userAgent.indexOf('yourappname') !== -1) {  // 'yourappname' 替换为你自己 App 的标识
        return 'app';
      }

      // 判断是否为 Web 网页
      if (typeof window !== 'undefined' && typeof document !== 'undefined') {
        return 'web';
      }

      return 'web';
    },
    getMobileOS() {
     const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    // 判断 iOS 设备
     if (/iPad|iPhone|iPod/.test(userAgent) || 
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
        this.os='ios'
       }
     // 判断 Android 设备
     if (/android/i.test(userAgent)) {
          this.os= 'Android';
      }
},
    // 关闭弹窗
    closeDialog() {
      this.loginShow = false
    },
    // 弹框
    showDialog() {
      if(this.$store.state.isPc){
        this.loginShow = true
        this.OneloginShow=false
      }
      else{
       this.loginShow = true
      }
      
      
    },
    // 区号点击弹出
    phoneAreaCodeChange(){
      this.areaCodeShow = true
    },
    areaCodeConfirm(value){
      this.areaCode = value
      this.areaCodeShow = false
    },
    //获取验证码
    getSmsCode() {
      if (this.loginForm.phone == '') {
        this.$toast(this.content.loginPhoneTip) // 请输入手机号
      } else if (/1[0-9]{10}$/.test(this.loginForm.phone)) {
        let domain_code = location.host.split('.')[1]
        axios.post('https://application.yunicu.com/user/sms/login/send?tel='+this.loginForm.phone+'&type='+ domain_code)
            .then(res => {
              // console.log(res)
              if (res.data.code === 0) { //发送成功
                this.$toast(this.content.verificationSuccess)
                this.isCount = true
                console.log('333'.res.data);
                
              } else if (res.data.code === -1) { //验证码发送失败
                this.$toast(this.content.verificationFail)
              } else if (res.data.code === -2) { //类型错误
                this.$toast(this.content.verificationTypeError)
              }else if (res.data.code === -3) { //验证发送过于频繁、请两分钟之后再试
                this.$toast(this.content.verificationFrequently)
              }else {
                this.$toast(this.content.verificationFail)
              }
            })

        // postSendSmsCode({
        //   phone: this.loginForm.phone,
        //   type: 'LOGIN',
        //   domain_code
        // }).then(res => {
        //   if (res.data.code == 0) {
        //     this.$toast(this.content.verificationSuccess)
        //     this.isCount = true
        //   } else {
        //     this.$toast(this.content.verificationFail)
        //   }
        // })
      } else {
        this.$toast(this.content.loginPhoneTip) // 请输入正确的手机号
      }
    },
    // 游客身份观看
    visitorBtn() {
      this.$emit('visitorLogin')
    },
    // 查看隐私协议
    lookPolicy(){
      this.$emit('lookPolicy')
    },
    // 登录按钮
    loginBtn() {
      const _this = this
      let domain_code = location.host.split('.')[1]
      if(this.type=='tel'){
          if (String(this.loginForm.phone).trim() && /1[0-9]{10}$/.test(this.loginForm.phone) && this.loginForm.sms_code && this.policyCheck) {
       let headers = {
         channel:this.getPlatform(), //mina,app,web
       }
       let data = {
         "tel": String(this.loginForm.phone).trim(),
         "sms": String(this.loginForm.sms_code).trim()//验证码
       }
        axios.post('https://application.yunicu.com/user/sms/login?type='+domain_code,data,{ headers })
            .then(res => {
              if (res.data.code === 0) {
                localStorage.setItem('x_token', res.data.data.token)
                if(this.$route.query.live_meeting_id == '2510' || this.$route.query.live_meeting_id == '2533'
                  || this.$route.query.live_meeting_id == '2595'
                ) {
                  // 20240125特殊处理：live_meeting_id=2510 和 2533的会议，未登录的需要再完善资料
                  _this.loginShow = false
                  this.resetForm()
                  this.$emit('needRegister', { id: res.data.data.id, phone: _this.loginForm.phone })
                }
                else {
                  if (res.data.data.is_summit == 0) { //需要完善资料，弹窗
                    _this.loginShow = false;
                    this.resetForm()
                    //调用index.vue中的needRegister方法；
                    this.$emit('needRegister', { id: res.data.data.id, phone: _this.loginForm.phone })
                    // // 未注册过需要完善资料
                    // const res1 = await postUserInfo({
                    //   member_id: res.data.data.id
                    // })
                    // if (res1.data.code == 0) {
                    //   _this.perfectForm = { // 完善框表单
                    //     name: res1.data.data.name,
                    //     hospital_name: res1.data.data.hospital_name,
                    //     hospital_offices: res1.data.data.hospital_offices,
                    //     job_title: res1.data.data.job_title,
                    //   }
                    // }
                    // _this.perfectShow = true
                  } else {
                    // 登录成功后且不需要完善资料，则自动记录memberId，下次自动登录
                    localStorage.setItem('loginItem', JSON.stringify({ userId: res.data.data.id }))
                    _this.$toast(_this.content.loginSuccess)
                    _this.loginShow = false
                    this.resetForm()
                    this.$emit('loginSuccess', { id: res.data.data.id, phone: _this.loginForm.phone })
                    // // 拿到conventionId
                    // if (_this.$route.query.conventionId) {
                    //   const res1 = await postCheckLoginPay({
                    //     convention_id: _this.$route.query.conventionId,
                    //     member_id: res.data.data.id,
                    //   })
                    //   if (res1.data.code == 0) {
                    //     if (res1.data.data.is_allow_live) {
                    //       // 可观看，跳转直播页面
                    //       _this.$router.replace({
                    //         path: '/chat-online',
                    //         query: {
                    //           memberId: res.data.data.id,
                    //           room: _this.$route.query.room,
                    //           conventionId: _this.$route.query.conventionId
                    //         }
                    //       })
                    //     } else {
                    //       // 不可观看
                    //       _this.$toast('很抱歉，您没有直播观看权限')
                    //     }
                    //   } else {
                    //     _this.$toast('获取直播观看权限失败，请稍后再试');
                    //   }
                    // } else {
                    //   // 已注册过
                    //   setTimeout(() => {
                    //     _this.$router.replace({
                    //       path: '/chat-online',
                    //       query: {
                    //         memberId: res.data.data.id,
                    //         room: _this.$route.query.room,
                    //         conventionId: _this.$route.query.conventionId
                    //       }
                    //     })
                    //   }, 400)
                    // }
                  }
                }
              } else {
                _this.$toast(_this.content.loginFail)
                this.$emit('loginFail')
              }
            })

        // postLogin({
        //   live_stream_id: this.streamId,
        //   phone: String(this.loginForm.phone).trim(),
        //   code: String(this.loginForm.sms_code).trim()
        // }).then(async res => {
        //   if (res.data.code == 0) {
        //     localStorage.setItem('x_token', res.data.data.token)
        //     if(this.$route.query.live_meeting_id == '2510') {
        //       // 20240125特殊处理：live_meeting_id=2510的会议，未登录的需要再完善资料
        //       _this.loginShow = false
        //       this.resetForm()
        //       this.$emit('needRegister', { id: res.data.data.id, phone: _this.loginForm.phone })
        //     }
        //     else {
        //       if (res.data.data.is_summit == 0) { //需要完善资料，弹窗
        //         _this.loginShow = false;
        //         this.resetForm()
        //         //调用index.vue中的needRegister方法；
        //         this.$emit('needRegister', { id: res.data.data.id, phone: _this.loginForm.phone })
        //         // // 未注册过需要完善资料
        //         // const res1 = await postUserInfo({
        //         //   member_id: res.data.data.id
        //         // })
        //         // if (res1.data.code == 0) {
        //         //   _this.perfectForm = { // 完善框表单
        //         //     name: res1.data.data.name,
        //         //     hospital_name: res1.data.data.hospital_name,
        //         //     hospital_offices: res1.data.data.hospital_offices,
        //         //     job_title: res1.data.data.job_title,
        //         //   }
        //         // }
        //         // _this.perfectShow = true
        //       } else {
        //         // 登录成功后且不需要完善资料，则自动记录memberId，下次自动登录
        //         localStorage.setItem('loginItem', JSON.stringify({ userId: res.data.data.id }))
        //         _this.$toast(_this.content.loginSuccess)
        //         _this.loginShow = false
        //         this.resetForm()
        //         this.$emit('loginSuccess', { id: res.data.data.id, phone: _this.loginForm.phone })
        //         // // 拿到conventionId
        //         // if (_this.$route.query.conventionId) {
        //         //   const res1 = await postCheckLoginPay({
        //         //     convention_id: _this.$route.query.conventionId,
        //         //     member_id: res.data.data.id,
        //         //   })
        //         //   if (res1.data.code == 0) {
        //         //     if (res1.data.data.is_allow_live) {
        //         //       // 可观看，跳转直播页面
        //         //       _this.$router.replace({
        //         //         path: '/chat-online',
        //         //         query: {
        //         //           memberId: res.data.data.id,
        //         //           room: _this.$route.query.room,
        //         //           conventionId: _this.$route.query.conventionId
        //         //         }
        //         //       })
        //         //     } else {
        //         //       // 不可观看
        //         //       _this.$toast('很抱歉，您没有直播观看权限')
        //         //     }
        //         //   } else {
        //         //     _this.$toast('获取直播观看权限失败，请稍后再试');
        //         //   }
        //         // } else {
        //         //   // 已注册过
        //         //   setTimeout(() => {
        //         //     _this.$router.replace({
        //         //       path: '/chat-online',
        //         //       query: {
        //         //         memberId: res.data.data.id,
        //         //         room: _this.$route.query.room,
        //         //         conventionId: _this.$route.query.conventionId
        //         //       }
        //         //     })
        //         //   }, 400)
        //         // }
        //       }
        //     }
        //   } else {
        //     _this.$toast(_this.content.loginFail)
        //     this.$emit('loginFail')
        //   }
        // })
      } else if(!this.policyCheck){
        this.$toast(this.content.needCheckPolicy)
      } else {
        this.$toast(this.content.correctLoginTip)
      }
      }
      else{
      if (String(this.loginForm.phone).trim() && /1[0-9]{10}$/.test(this.loginForm.phone) && this.loginForm.password && this.policyCheck) {
       let headers = {
         channel:this.getPlatform(), //mina,app,web
       }
       let data = {
         "tel": String(this.loginForm.phone).trim(),
         "password": String(this.loginForm.password).trim()//密码
         }
          axios.post('https://application.yunicu.com/user/login/password/live',data,{ headers })
            .then(res => {
              if (res.data.code === 0) {
                localStorage.setItem('x_token', res.data.data.token)
                if(this.$route.query.live_meeting_id == '2510' || this.$route.query.live_meeting_id == '2533'
                  || this.$route.query.live_meeting_id == '2595'
                ) {
                  // 20240125特殊处理：live_meeting_id=2510 和 2533的会议，未登录的需要再完善资料
                  _this.loginShow = false
                  this.resetForm()
                  this.$emit('needRegister', { id: res.data.data.id, phone: _this.loginForm.phone })
                }
                else {
                  if (res.data.data.is_summit == 0) { //需要完善资料，弹窗
                    _this.loginShow = false;
                    this.resetForm()
                    //调用index.vue中的needRegister方法；
                    this.$emit('needRegister', { id: res.data.data.id, phone: _this.loginForm.phone })
                    // // 未注册过需要完善资料
                    // const res1 = await postUserInfo({
                    //   member_id: res.data.data.id
                    // })
                    // if (res1.data.code == 0) {
                    //   _this.perfectForm = { // 完善框表单
                    //     name: res1.data.data.name,
                    //     hospital_name: res1.data.data.hospital_name,
                    //     hospital_offices: res1.data.data.hospital_offices,
                    //     job_title: res1.data.data.job_title,
                    //   }
                    // }
                    // _this.perfectShow = true
                  } else {
                    // 登录成功后且不需要完善资料，则自动记录memberId，下次自动登录
                    localStorage.setItem('loginItem', JSON.stringify({ userId: res.data.data.id }))
                    _this.$toast(_this.content.loginSuccess)
                    _this.loginShow = false
                    this.resetForm()
                    this.$emit('loginSuccess', { id: res.data.data.id, phone: _this.loginForm.phone })
                    // // 拿到conventionId
                    // if (_this.$route.query.conventionId) {
                    //   const res1 = await postCheckLoginPay({
                    //     convention_id: _this.$route.query.conventionId,
                    //     member_id: res.data.data.id,
                    //   })
                    //   if (res1.data.code == 0) {
                    //     if (res1.data.data.is_allow_live) {
                    //       // 可观看，跳转直播页面
                    //       _this.$router.replace({
                    //         path: '/chat-online',
                    //         query: {
                    //           memberId: res.data.data.id,
                    //           room: _this.$route.query.room,
                    //           conventionId: _this.$route.query.conventionId
                    //         }
                    //       })
                    //     } else {
                    //       // 不可观看
                    //       _this.$toast('很抱歉，您没有直播观看权限')
                    //     }
                    //   } else {
                    //     _this.$toast('获取直播观看权限失败，请稍后再试');
                    //   }
                    // } else {
                    //   // 已注册过
                    //   setTimeout(() => {
                    //     _this.$router.replace({
                    //       path: '/chat-online',
                    //       query: {
                    //         memberId: res.data.data.id,
                    //         room: _this.$route.query.room,
                    //         conventionId: _this.$route.query.conventionId
                    //       }
                    //     })
                    //   }, 400)
                    // }
                  }
                }
              } else {
                _this.$toast(res.data.message)
                this.$emit('loginFail')
              }
            })

        // postLogin({
        //   live_stream_id: this.streamId,
        //   phone: String(this.loginForm.phone).trim(),
        //   code: String(this.loginForm.sms_code).trim()
        // }).then(async res => {
        //   if (res.data.code == 0) {
        //     localStorage.setItem('x_token', res.data.data.token)
        //     if(this.$route.query.live_meeting_id == '2510') {
        //       // 20240125特殊处理：live_meeting_id=2510的会议，未登录的需要再完善资料
        //       _this.loginShow = false
        //       this.resetForm()
        //       this.$emit('needRegister', { id: res.data.data.id, phone: _this.loginForm.phone })
        //     }
        //     else {
        //       if (res.data.data.is_summit == 0) { //需要完善资料，弹窗
        //         _this.loginShow = false;
        //         this.resetForm()
        //         //调用index.vue中的needRegister方法；
        //         this.$emit('needRegister', { id: res.data.data.id, phone: _this.loginForm.phone })
        //         // // 未注册过需要完善资料
        //         // const res1 = await postUserInfo({
        //         //   member_id: res.data.data.id
        //         // })
        //         // if (res1.data.code == 0) {
        //         //   _this.perfectForm = { // 完善框表单
        //         //     name: res1.data.data.name,
        //         //     hospital_name: res1.data.data.hospital_name,
        //         //     hospital_offices: res1.data.data.hospital_offices,
        //         //     job_title: res1.data.data.job_title,
        //         //   }
        //         // }
        //         // _this.perfectShow = true
        //       } else {
        //         // 登录成功后且不需要完善资料，则自动记录memberId，下次自动登录
        //         localStorage.setItem('loginItem', JSON.stringify({ userId: res.data.data.id }))
        //         _this.$toast(_this.content.loginSuccess)
        //         _this.loginShow = false
        //         this.resetForm()
        //         this.$emit('loginSuccess', { id: res.data.data.id, phone: _this.loginForm.phone })
        //         // // 拿到conventionId
        //         // if (_this.$route.query.conventionId) {
        //         //   const res1 = await postCheckLoginPay({
        //         //     convention_id: _this.$route.query.conventionId,
        //         //     member_id: res.data.data.id,
        //         //   })
        //         //   if (res1.data.code == 0) {
        //         //     if (res1.data.data.is_allow_live) {
        //         //       // 可观看，跳转直播页面
        //         //       _this.$router.replace({
        //         //         path: '/chat-online',
        //         //         query: {
        //         //           memberId: res.data.data.id,
        //         //           room: _this.$route.query.room,
        //         //           conventionId: _this.$route.query.conventionId
        //         //         }
        //         //       })
        //         //     } else {
        //         //       // 不可观看
        //         //       _this.$toast('很抱歉，您没有直播观看权限')
        //         //     }
        //         //   } else {
        //         //     _this.$toast('获取直播观看权限失败，请稍后再试');
        //         //   }
        //         // } else {
        //         //   // 已注册过
        //         //   setTimeout(() => {
        //         //     _this.$router.replace({
        //         //       path: '/chat-online',
        //         //       query: {
        //         //         memberId: res.data.data.id,
        //         //         room: _this.$route.query.room,
        //         //         conventionId: _this.$route.query.conventionId
        //         //       }
        //         //     })
        //         //   }, 400)
        //         // }
        //       }
        //     }
        //   } else {
        //     _this.$toast(_this.content.loginFail)
        //     this.$emit('loginFail')
        //   }
        // })
         }
      else if(!this.policyCheck){
        this.$toast(this.content.needCheckPolicy)
      }
      else if(!(String(this.loginForm.phone).trim() && /1[0-9]{10}$/.test(this.loginForm.phone))){
        this.$toast(this.content.correctLoginTipTel)
      }
      else {
          this.$toast(this.content.correctLoginTipTelPassword)
      }
    }
    },
    changeType(){
         this.type=this.type=='tel'?'password':'tel'
    },
    resetForm() {
      this.loginForm = { // 登录框表单
        phone: '',
        sms_code: ''
      }
    },
    changeLoginShow(){
           this.loginShow=true,
           this.OneloginShow=false
    },
  async  getTelNumber(){
        var loginPhoneEle = document.getElementById("J_loginPhone");
        this.phoneNumberServer = new PhoneNumberServer();
        console.log(loginPhoneEle,this.phoneNumberServer);
        await  this.getAccessToken()
  },
  getAccessToken(){
          axios.get('https://application.yunicu.com/user/ali/login/token?type=live')
            .then(res => {
                   if(res.data.code==0){
                            this.tokenInfo.JwtToken=res.data.data.jwtToken
                            this.tokenInfo.AccessToken=res.data.data.accessToken
                            this.checkLogin(this.tokenInfo.JwtToken, this.tokenInfo.AccessToken);                
                   }
                   else{
                       this.$toast('登录失败，请尝试其他登录方式！')
                   }
            })
            .catch(error => {
                   this.$toast('登录失败，请尝试其他登录方式！')
              })
    },
  checkLogin(jwtToken, accessToken) {
       let that=this
       that.phoneNumberServer.checkLoginAvailable({
          accessToken: accessToken,
          jwtToken: jwtToken,
          success: function (res) {
            that.getToken1();
          },
           error: function (res) {
           that.$toast("身份鉴权失败");
          },
        });
      },
    getToken1() {
        let that=this  
        that.phoneNumberServer.getLoginToken({
          // 成功回调
          success: function (res) {
            that.getPhone(res.spToken);
            // 一键登录: 可发请求到服务端调用 GetPhoneWithToken API, 获取用户手机号, 完成登录
          },
          // 失败回调
          error: function (res) {
            that.$toast(JSON.stringify(res))
          },
          // 授权页状态监听函数
          watch: function (status, data) {
          },
          // 配置选项
          authPageOption: {
            logoImg:'https://yunicu.com/img/titleImg.9849ea77.png',
            navText:'',
            subtitle: "请开启数据流量，关闭wifi尝试此功能！", // 副标题
            btnText: "立即登录",
            privacyTwo:['隐私协议'],
            agreeSymbol: "、",
            showCustomView: true,
            privacyBefore: "我已阅读并同意",
            isDialog: true, // 是否是弹窗样式
            manualClose: false, // 是否手动关闭弹窗/授权页
                  customView: {
              element:
                '<div class="btn_box other" onclick="clickEvent()">切换其他登录方式</div>',
              style: ".btn_box.other{background: #fff; color: #2284E5}",
              js: `function clickEvent(){ 
               const global = globalThis.vueApp;
                global.clickEventChange()
                 
                    
                 }`,
            },
          },
        });
      },
      clickEventChange(){
          this.phoneNumberServer.closeLoginPage();
          this.loginShow=true
          this.OneloginShow=false
      },
    getPhone(spToken) {
         let that=this
         let headers={
            channel:'web',
            os:that.os,
         }
          axios.get('https://application.yunicu.com/user/ali/login/h5/verify?sptoken='+spToken,{headers})
            .then(res => {
                 if(res.data.code==0){
                    that.$toast('登录成功！')
                    localStorage.setItem('x_token', res.data.data.token)
                    that.phoneNumberServer.closeLoginPage();
                    that.OneloginShow = false      
                    if(that.$route.query.live_meeting_id == '2510' || that.$route.query.live_meeting_id == '2533'
                       || that.$route.query.live_meeting_id == '2595'
                    ) {
                     // 20240125特殊处理：live_meeting_id=2510 和 2533的会议，未登录的需要再完善资料
                     that.OneloginShow = false  
                     that.resetForm()
                     that.$emit('needRegister', { id: res.data.data.id, phone: res.data.data.tel })
                     }
                   else {
                  if (res.data.data.is_summit == 0) { //需要完善资料，弹窗
                    that.OneloginShow = false;
                    that.resetForm()
                    that.phoneNumberServer.closeLoginPage();
                    //调用index.vue中的needRegister方法；
                    that.$emit('needRegister', { id: res.data.data.id, phone: res.data.data.tel })
                  } else {
                    // 登录成功后且不需要完善资料，则自动记录memberId，下次自动登录
                    localStorage.setItem('loginItem', JSON.stringify({ userId: res.data.data.id }))
                    that.$toast(that.content.loginSuccess)
                    that.OneloginShow = false
                    that.resetForm()
                    that.phoneNumberServer.closeLoginPage();
                    that.$emit('loginSuccess', { id: res.data.data.id, phone:  res.data.data.tel })
                  }
                }
                 }
                 else {
                 that.$toast('登录失败！')
                 that.$emit('loginFail')
              }
            })
            .catch(error => {
                   this.$toast('登录失败，请尝试其他登录方式！')
              })
            },
            // 初始化微信登录
    initWechatLogin() {
          console.log('微信登录执行');
          
        let room=this.$route.query.room
        let live_meeting_id=this.$route.query.live_meeting_id
          const obj = new WxLogin({
              id: "qrcode-container",
               self_redirect: false,
              appid: "wx02d7d0387ff1b54c", // 这个appid要填死
              scope: "snsapi_login",
            // 扫码成功后重定向的接口
            redirect_uri: encodeURIComponent(`https://application.yunicu.com/user/oauth/wechat/redirect?env=live&live_meeting_id=${live_meeting_id}&room=${room}&`),
            // redirect_uri: "http://192.168.5.115:8080",
            // state填写编码后的url
            state: Math.ceil(Math.random() * 1000),
            // 调用样式文件
            href: "data:text/css;base64,Lyogd3hsb2dpbi5jc3MgKi8KLmltcG93ZXJCb3ggLnRpdGxlLCAuaW1wb3dlckJveCAuaW5mb3sKICBkaXNwbGF5OiBub25lOwp9CgouaW1wb3dlckJveCAucXJjb2RlewogIG1hcmdpbi10b3A6IDIwcHg7CiAgd2lkdGg6IDE5MHB4Owp9",
            });
             
         },
      //登录状态
        pollLoginStatus(code) { 
          let that=this
           axios.get(`https://application.yunicu.com/user/wx/login/${code}`)
            .then(res => {
                if(res.data.code==0){
                    that.$toast('登录成功！')
                    window.location.reload();
                    localStorage.setItem('x_token', res.data.data.member.token)
                    that.OneloginShow = false
                      if(that.$route.query.live_meeting_id == '2510' || that.$route.query.live_meeting_id == '2533'
                        || that.$route.query.live_meeting_id == '2595'
                      ) {
                    // 20240125特殊处理：live_meeting_id=2510 和 2533的会议，未登录的需要再完善资料
                    //  console.log( this.$route.query.live_meeting_id == '2510');
                     that.OneloginShow = false  
                     that.resetForm()
                     that.$emit('needRegister', { id: res.data.data.member.id, phone: res.data.data.member.tel })
                     }
                   else {
                  if (res.data.data.is_summit == 0) { //需要完善资料，弹窗
                    that.OneloginShow = false;
                    that.resetForm()
                    //调用index.vue中的needRegister方法；
                    that.$emit('needRegister', { id: res.data.data.member.id, phone: res.data.data.member.tel })
                  } 
                  else {
                    // 登录成功后且不需要完善资料，则自动记录memberId，下次自动登录
                    localStorage.setItem('loginItem', JSON.stringify({ userId: res.data.data.member.id }))
                    that.$toast(that.content.loginSuccess)
                    that.OneloginShow = false
                    that.resetForm()
                    that.$emit('loginSuccess', { id:res.data.data.member.id, phone: res.data.data.member.tel })
                  }
                 }
                 }
                else if(res.data.code==-1){
                  that.wxFormModel=true
                  that.OneloginShow=false
                  that.loginShow=false
                  that.unionId=res.data.data.unionId
                }
                   
                 
            })
           },
          
        changePC(type){
                 if(type=='tel'|| type=='password'){
                          this.OneloginShow=false
                          this.loginShow=true
                          this.type=type
                 }
                 else{
                         this.OneloginShow=true
                         this.loginShow=false
                          this.$nextTick(() => {
                           this.initWechatLogin()
                       })
                       
                 }
           },
        wxuuidLogin(){
          if(this.loginForm.phone==''){
               this.$toast('请输入手机号！');
               return
          }
          if(this.loginForm.code==''){
              this.$toast('请输入验证码！');
               return
          }
              let data={
                     tel:this.loginForm.phone,sms:this.loginForm.code,unionid:this.unionId//可选，用来绑定app微信
              }
              let type='yunicu'
              let bindWx=1
          
              axios.post(`https://application.yunicu.com/user/sms/login?type=${type}&bindWx=${bindWx}`,data).then(res=>{
                   if(res.data.code==0){
                    this.$toast('登录成功！')
                    localStorage.setItem('x_token', res.data.data.token)
                    this.wxFormModel = false
                      if(this.$route.query.live_meeting_id == '2510' || this.$route.query.live_meeting_id == '2533'
                        || this.$route.query.live_meeting_id == '2595'
                      ) {
                       
                        
                      // 20240125特殊处理：live_meeting_id=2510和2533的会议，未登录的需要再完善资料
                       this.wxFormModel = false 
                     this.resetForm()
                     this.$emit('needRegister', { id: res.data.data.id, phone: res.data.data.tel })
                     }
                   else {
                  if (res.data.data.is_summit == 0) { //需要完善资料，弹窗
                    this.wxFormModel = false
                    this.resetForm()
                    //调用index.vue中的needRegister方法；
                    this.$emit('needRegister', { id: res.data.data.id, phone: res.data.data.tel })
                  } 
                  else {
                    // 登录成功后且不需要完善资料，则自动记录memberId，下次自动登录
                    localStorage.setItem('loginItem', JSON.stringify({ userId: res.data.data.id }))
                    this.$toast(this.content.loginSuccess)
                    this.wxFormModel = false
                    this.resetForm()
                    this.$emit('loginSuccess', { id:res.data.data.id, phone: res.data.data.tel })
                  }
                 }
                   }
                   else {
                   this.$toast(res.data.message);
                   }             
                })
                .catch(error => {
                    this.$toast(error)
              })
           },







}
}
  
</script>

<style lang="less" scoped>
div {
  box-sizing: border-box;
}
.van-dialog {
  border-radius: 6px;
}
.auth-login-container {
  .login-content-pc{
    padding: 0 0.35rem;
    .login-form-p{
      padding: 0 0.4rem;
    }
    .title {
      font-size: 0.23rem;
      color: #131313;
      font-weight: bold;
      text-align: center;
      margin-top: 0.33rem;
      margin-bottom: 0.1rem;
    }
    .close-icon {
      position: absolute;
      top: 0.33rem;
      right: 0.3rem;
      cursor: pointer;
    }
    .input-p{
      margin-bottom: 0.2rem;
    }
    .policy-check{
      margin-top: 0.1rem;
      .policy-link{
        color: #2284E5;
      }
      /deep/.van-checkbox__label {
        font-size: 0.17rem;
      }
      /deep/.van-icon{
        line-height: 1;
      }
    }
    .loginBtn {
      width: 2.8rem;
      height: 0.55rem;
      margin: 0.2rem auto 0.2rem;
      display: block;
    }
    .visitorBtn {
      width: 2.8rem;
      height: 0.55rem;
      margin: 0.1rem auto 0.2rem;
      border-style: solid;
      display: block;
    }
  }
  .login-content {
    // height: 4rem;
    // width:100%;

    padding: 0 0.25rem;
    .title {
      font-size: 0.23rem;
      color: #131313;
      font-weight: bold;
      text-align: center;
      margin-top: 0.33rem;
      margin-bottom: 0.2rem;
    }
    .close-icon {
      position: absolute;
      top: 0.23rem;
      right: 0.23rem;
      cursor: pointer;
    }
    .van-cell {
      margin-top: 0.1rem;
      padding: 0.13333rem 0;
    }
    .policy-check{
      margin-top: 0.1rem;
      .policy-link{
        color: #2284E5;
      }
      /deep/.van-checkbox__label {
        font-size: 0.16rem;
      }
    }
    .loginBtn {
      width: 2.8rem;
      height: 0.45rem;
      margin: 0.2rem auto 0.2rem;
      display: block;
    }
    .visitorBtn {
      width: 2.8rem;
      height: 0.45rem;
      margin: 0.1rem auto 0.1rem;
      border-style: solid;
      display: block;
    }
  }
  .van-popup{
    position: absolute;
  }
}
.bottom{
    height: 80px;
    line-height: 80px;
    display: flex;
    align-content: center;


}
.passwordTitle{
    font-size: 0.20rem;
    color: #2284E5;

}
.passwordTitle-tel{
    font-size: 0.20rem;
    color: #2284E5;
    padding-bottom: 0.5rem;
    cursor: pointer;
}
.boxOneLogin{
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
// 此处修改协议勾选、选中时的颜色
.dialog-type-container .agreement .checke-1 svg g {
    fill: blue !important
}
// 此处修改登录按钮的样式：颜色大小背景色等
/deep/ .dialog-type-container .submit-btn{
    color: #2284E5 !important;
    background: #2284E5;
}
.login-wx-body {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  
   
}
.PCTitle{
      font-size: 15px;
      margin-top:10px
      
}
.PCdialog{
   
    height:320px;
   
}
.WEITitle{
      font-size: 12px;
      margin-top:200px;
}
.qrcode-container{
       height: 240px;
       

}.weiBOttom{
     color:#2284E5;
     width: 30%;
     display: flex;
     justify-content: space-between;
     cursor: pointer;
}
</style>
